import script from "./BetInfoBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./BetInfoBlock.vue?vue&type=script&setup=true&lang=js"

import "./BetInfoBlock.vue?vue&type=style&index=0&id=2f222fe2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f222fe2"]])

export default __exports__